import React, { Component, Fragment } from "react";
import { optionsType } from "../punishmentSubsidiary";
import Attachment from "../attachment";
import arrowdown from "../../static/images/arrowdown.png";
import { compare } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import Moment from "moment";
import styles from "./index.less";

interface Props {
  index: number;
  options: optionsType;
  itemsLength: number;
  type?: string;
  appealStatus: number | undefined;
  getDetailData: (caseId: string | number, templateId: string | number) => void;
  setModalType?: () => void;
  setRevokeType?: () => void;
}

interface State {
  caseId: number | string;
  unfoldButton: boolean;
}

class ProgressCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      caseId: 0,
      unfoldButton: false,
    };
  }

  /**
   * @description 补充资料操作
   *
   **/
  onSupply = (caseId: number | string) => {
    this.props.setModalType();
    this.setState({
      caseId,
    });
  };

  /**
   * @description 撤销操作
   *
   **/
  onRevoke = (caseId: number | string) => {
    this.props.setRevokeType();
    this.setState({
      caseId,
    });
  };

  showSpread = () => {
    this.setState({
      unfoldButton: true,
    });
  };

  /**
   * @description 渲染附件
   *
   **/
  renderInfoNode = (actionCodeTalkingSkill: any, replyContent: string) => {
    const { instructionMap } = this.props.options;
    const { unfoldButton } = this.state;
    return (
      <div className={styles.infoNode}>
        <span className={styles.actionCodeTalkingSkill}>
          {actionCodeTalkingSkill}
        </span>
        <div className={styles.replyContent}>
          <div className={styles.writtenContent}>
            <span className={styles.message}>
              {unfoldButton ? replyContent : replyContent.substring(0, 121)}
            </span>
            {replyContent.length > 121 && !unfoldButton ? (
              <Fragment>
                <span className={styles.ellipsis}>...</span>
                <span className={styles.spread} onClick={this.showSpread}>
                  展开 <img src={arrowdown} />
                </span>
              </Fragment>
            ) : null}
          </div>
          {Array.isArray(instructionMap.attachment) ? (
            <div className={styles.attachment}>
              {instructionMap.attachment
                .sort(compare("fileType"))
                .map((item: any, index: number) => {
                  return (
                    <Fragment key={index}>
                      <Attachment
                        type={item.fileType}
                        path={item.attachmentPath}
                        name={item.attachmentName}
                        source="detail"
                      />
                    </Fragment>
                  );
                })}
            </div>
          ) : (
            this.renderAppAttachment(instructionMap.attachment)
          )}
        </div>
      </div>
    );
  };

  /**
   * @description 兼容app\后台
   *
   **/
  renderAppAttachment = (attachment) => {
    const imgReg = /.\.(png|jpg|jpeg)$/i;
    let attachmentArr = attachment ? attachment.split("|") : [];
    // const fileReg = /(rar|txt|doc|pdf|zip)/gi;
    return (
      <div className={styles.attachment}>
        {attachmentArr.map((item: string, index: number) => {
          return (
            imgReg.test(item) && (
              <Attachment key={index} type={1} path={item} source="detail" />
            )
          );
        })}
      </div>
    );
  };

  /**
   * @description 渲染时间阶段
   *
   **/
  renderProgressNode = () => {
    const { options, type } = this.props;
    const {
      actionSuc,
      actionSucTalkingSkill,
      caseId,
      actionCode,
      actionCodeTalkingSkill,
      instructionMap,
    } = options;
    switch (type) {
      case "suc":
        return actionCode === 1 ? (
          <div className={styles.submittedSuccess}>
            <span>
              {actionSuc}
              {caseId}
            </span>
            <span className={styles.talkSkill}>{actionSucTalkingSkill}</span>
          </div>
        ) : null;
      default:
        return (
          <Fragment>
            {actionCode !== 9 &&
            actionCodeTalkingSkill &&
            instructionMap &&
            instructionMap.replyContent
              ? this.renderInfoNode(
                  actionCodeTalkingSkill,
                  instructionMap.replyContent
                )
              : null}
            {actionCodeTalkingSkill && instructionMap === undefined ? (
              <div>{actionCodeTalkingSkill}</div>
            ) : null}
            {actionCode !== 9 &&
            actionCodeTalkingSkill &&
            instructionMap &&
            instructionMap.content
              ? this.renderInfoNode(
                  actionCodeTalkingSkill,
                  instructionMap.content
                )
              : null}
          </Fragment>
        );
    }
  };

  render() {
    const { options, type, index, itemsLength, appealStatus } = this.props;
    let {
      actionCodeRedIcon,
      actionCodeIcon,
      actionCodeName,
      operators,
      actionSucRedIcon,
      actionSucIcon,
      actionSucName,
      actionSucOperator,
      actionCode,
      caseId,
      actionType,
      illegalType,
    } = options;
    actionCodeRedIcon =
      type === "suc" && actionSucRedIcon ? actionSucRedIcon : actionCodeRedIcon;
    actionCodeIcon =
      type === "suc" && actionSucIcon ? actionSucIcon : actionCodeIcon;
    actionCodeName =
      type === "suc" && actionSucName ? actionSucName : actionCodeName;
    operators = type === "suc" ? actionSucOperator : operators;
    return (
      <Fragment>
        <div className={styles.progressCard}>
          <div className={styles.timeLine}>
            <span className={styles.date}>
              {Moment(options.createDate).format("YYYY-MM-DD")}
            </span>
            <span className={styles.time}>
              {Moment(options.createDate).format("HH:mm:ss")}
            </span>
          </div>
          <div
            className={styles.container}
            style={{
              borderColor:
                index === 0
                  ? "#FF3D69"
                  : index === itemsLength - 1
                  ? "none"
                  : "#cccccc",
            }}
          >
            <div
              className={`${index === 0 ? styles.progress_img_red : ""} ${
                styles.progress_img
              }`}
            >
              <img
                className={styles.timeNode}
                src={index === 0 ? actionCodeRedIcon : actionCodeIcon}
              />
            </div>
            {
              <div
                className={styles.title}
                style={{ color: index === 0 ? "#FF3D69" : "#303233" }}
              >
                {actionCodeName}
              </div>
            }
            <div className={styles.content}>{this.renderProgressNode()}</div>
            {operators ? (
              <div className={styles.person}>
                <span>{operators.slice(0, 4)} </span>
                {operators.slice(5)}
              </div>
            ) : actionType === 1 ? (
              <div className={styles.person}>
                <span> 经办人: </span>
                用户
              </div>
            ) : (
              <div className={styles.person}>
                <span>经办人: </span>
                平台客服
              </div>
            )}
            {index === 0 && (actionCode === 3 || appealStatus === 1) ? (
              <div className={styles.detailCaseBtn}>
                {actionCode === 3 ? (
                  <span
                    className={styles.supplement}
                    onClick={() => {
                      burying(
                        "2",
                        "button-appeal-detail",
                        `button=1$status=${appealStatus}$appealid=${caseId}`,
                        "ss-05",
                        "undefined"
                      );
                      this.onSupply(caseId);
                    }}
                  >
                    补充资料
                  </span>
                ) : null}
                {appealStatus === 1&&illegalType!=2 ? (
                  <span
                    className={styles.undo}
                    onClick={() => {
                      burying(
                        "2",
                        "button-appeal-detail",
                        `button=0$status=${appealStatus}$appealid=${caseId}`,
                        "ss-05",
                        "undefined"
                      );
                      this.onRevoke(caseId);
                    }}
                  >
                    撤销申诉
                  </span>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ProgressCard;
